// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2156) return "static/chunks/e99863e0-6fde245b9ca2ab80.js";
	if (chunkId === 6652) return "static/chunks/8e68d877-64c7ef430ce4d92b.js";
	if (chunkId === 3406) return "static/chunks/3406-047ac042240ba141.js";
	if (chunkId === 2452) return "static/chunks/2452-fa5e6bd8b6e875f0.js";
	if (chunkId === 5625) return "static/chunks/5625-a57a4efe2835511a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2873":"3fab93e98e1034c5","3463":"6c35fa7931c388fd","4259":"6136023808deb521","4724":"82abe04e6fa0444f","6320":"ccf0d1f4f563400d","9780":"41f4c01a70954f19"}[chunkId] + ".js";
};